import { guardPlatformOnly } from '../RequirePermission';
import { ReleaseKeyPage } from './ReleaseKeyPage';

export { ReleaseKeyPage };
export const ReleaseKeyRoute = guardPlatformOnly('kiosk-releases:read:all', ReleaseKeyPage);
